/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalEntityRequest } from './';
import {
    LegalEntityRequestFromJSON,
    LegalEntityRequestFromJSONTyped,
    LegalEntityRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalEntityWithClientTeamsRequest
 */
export interface LegalEntityWithClientTeamsRequest {
    /**
     * 
     * @type {LegalEntityRequest}
     * @memberof LegalEntityWithClientTeamsRequest
     */
    legalEntity: LegalEntityRequest;
    /**
     * 
     * @type {Set<string>}
     * @memberof LegalEntityWithClientTeamsRequest
     */
    clientTeams: Set<string>;
}

/**
 * Check if a given object implements the LegalEntityWithClientTeamsRequest interface.
 */
export function instanceOfLegalEntityWithClientTeamsRequest(value: object): value is LegalEntityWithClientTeamsRequest {
    if (!('legalEntity' in value) || value['legalEntity'] === undefined) return false;
    if (!('clientTeams' in value) || value['clientTeams'] === undefined) return false;
    return true;
}

export function LegalEntityWithClientTeamsRequestFromJSON(json: any): LegalEntityWithClientTeamsRequest {
    return LegalEntityWithClientTeamsRequestFromJSONTyped(json, false);
}

export function LegalEntityWithClientTeamsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityWithClientTeamsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntity': LegalEntityRequestFromJSON(json['legalEntity']),
        'clientTeams': json['clientTeams'],
    };
}

export function LegalEntityWithClientTeamsRequestToJSON(value?: LegalEntityWithClientTeamsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntity': LegalEntityRequestToJSON(value['legalEntity']),
        'clientTeams': Array.from(value['clientTeams'] as Set<any>),
    };
}

